// extracted by mini-css-extract-plugin
export default {"root":"STmKkKOEQq","inputWrapper":"u3Qq27EV2Q","emptyDataPlaceholder":"psUzb3UZZz","tagsContainer":"Tgh0ZLQY2e"};